/**
 * useChartTheme — kolory wykresu (paleta, siatka, tor) dla bieżącego motywu jasny/ciemny.
 *
 * Czyta klasę `dark` z `<html>` (ustawia ją `ThemeProvider`) przez MutationObserver, więc
 * nie wymaga providera motywu — działa też w testach i w izolowanych hostach widgetów.
 */

import { useSyncExternalStore } from 'react';

import {
  CHART_GRID,
  CHART_GRID_DARK,
  CHART_PALETTE,
  CHART_PALETTE_DARK,
  CHART_TRACK,
  CHART_TRACK_DARK,
} from './chart-colors';

function subscribe(onChange: () => void): () => void {
  if (typeof document === 'undefined') return () => undefined;
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  return () => observer.disconnect();
}

function getIsDark(): boolean {
  return typeof document !== 'undefined' && document.documentElement.classList.contains('dark');
}

export interface ChartTheme {
  isDark: boolean;
  palette: readonly string[];
  grid: string;
  track: string;
}

const LIGHT: ChartTheme = {
  isDark: false,
  palette: CHART_PALETTE,
  grid: CHART_GRID,
  track: CHART_TRACK,
};
const DARK: ChartTheme = {
  isDark: true,
  palette: CHART_PALETTE_DARK,
  grid: CHART_GRID_DARK,
  track: CHART_TRACK_DARK,
};

export function useChartTheme(): ChartTheme {
  const isDark = useSyncExternalStore(subscribe, getIsDark, () => false);
  return isDark ? DARK : LIGHT;
}
